import Vue from 'vue'
import Router from './router'
import Store from './store'

// import io from '../libs/sailsjs/sails.io.js'
// Vue.use(io)
// help - https://www.npmjs.com/package/vue-sails.io
// import VueSailsIO from 'vue-sails.io'
// Vue.use(VueSailsIO, 'http://no_url') // no url is known at the moment; пустым второй параметр нельзя оставлять тогда ошибка в console выдется
// Vue.use(VueSailsIO, 'http://localhost:1778') // no url is known at the moment; пустым второй параметр нельзя оставлять тогда ошибка в console выдется

import iView from '../libs/iview'
import '../libs/iview/dist/styles/iview.css'
import iViewLocale from '../libs/iview/dist/locale/ru-RU.js'
Vue.use(iView, {locale: iViewLocale})

import ElementUI from '../libs/element-ui'
// import '../libs/element-ui/lib/theme-default/index.css'
import '../libs/element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import '../libs/bootstrap/dist/css/bootstrap.min.css'
// import '../libs/font-awesome/css/fontawesome.min.css'
import '../libs/font-awesome/css/all.min.css'
import '../libs/font-awesome/css/regular.min.css'
import '../libs/font-awesome/css/solid.min.css'

// import VueApexCharts from 'vue-apexcharts'
// Vue.use(VueApexCharts)
// Vue.component('apexchart', VueApexCharts)

// import jQ from '@/../libs/jquery-3.3.1/jquery.min.js'
// Vue.use(jQ)
// import ckeditor from 'ckeditor'
// Vue.use(ckeditor)

import numeral from 'numeral'

import http from 'axios'
http.defaults.withCredentials = true // нужно чтобы потом все requests к cross-origin-серверу проходили с куки и следовательно с куки авторизованной сессии

// return str1 < str2 : -1 | str1 > str2 : 1
function mystrcmp (str1, str2) {
  // вариант 1
  // return (str1 < str2 ? -1 : (str2 > str1 ? 1 : 0))
  // console.log(str1 + ' | ' + str2)

  // вариант 2
  if ((str1 == null) || (str1 === '')) { if ((str2 == null) || (str2 === '')) return 0; else return -1 } // или 0 или str1 здесь null а str2 не null значит str1 < str2
  if ((str2 == null) || (str2 === '')) return 1 // str1 здесь уже не null значит str1 > str2
  for (var i = 0; i < str1.length; i++) {
    if (str1[i] === str2[i]) continue
    if (str2[i] == null) return 1
    if (str1[i] > str2[i]) return 1; else return -1
  }
  return 0
}

// !!!! заменить присвоение на Vue.set, а название на deepCloneObject
function cloneObject (obj) { // не предназначен для входного array !!!
  if (obj == null) return null
  var newObj = {}
  for (var key in obj) {
    if (obj[key] == null) { // надо так как в доке написано что typeof null == "object" а нам это не надо иначе запустим cloneObject
      newObj[key] = obj[key]
    } else if (typeof obj[key] === 'object') {
      newObj[key] = cloneObject(obj[key])
    } else {
      newObj[key] = obj[key]
    }
  }
  return newObj
}
function cloneObjectWithoutFns (obj) {
  if (obj == null) return null
  var newObj = {}
  for (var key in obj) {
    if (obj[key] == null) { // надо так как в доке написано что typeof null == "object" а нам это не надо иначе запустим cloneObject
      newObj[key] = obj[key]
    } else if (typeof obj[key] === 'object') {
      newObj[key] = cloneObject(obj[key])
    } else if (typeof obj[key] === 'function') {
      // skip this prop
    } else {
      newObj[key] = obj[key]
    }
  }
  return newObj
}

/*
Vue.filter('convertStrEntersToHtmlBRTags', function (value, format) {
  if (value == null) return null
  console.log(typeof value)
  return value.replace('\n', '<br>')
})
*/

const weekDaysNames = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
const monthsNames = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь']
Vue.filter('formatDate', function (value, format) {
  // console.log(value)
  if (value) {
    var result = ''
    value = new Date(value)
    if ((format == null) || (format === 'date')) {
      if (value.getDate() < 10) { result += '0' }
      var month = value.getMonth() + 1; if (month < 10) month = '0' + month
      return result + value.getDate() + '.' + month + '.' + value.getFullYear()
    }
    if (format === 'month') {
      month = value.getMonth() + 1; if (month < 10) month = '0' + month
      return month + '.' + value.getFullYear()
    }
    if (format === 'monthAsWord') {
      month = value.getMonth()
      return monthsNames[month] + ' ' + value.getFullYear()
    }
    if (format === 'day + weekday') {
      if (value.getDate() < 10) { result += '0' }
      return result + value.getDate() + ', ' + weekDaysNames[value.getDay()]
    }
    if (format === 'date + weekday') {
      if (value.getDate() < 10) { result += '0' }
      month = value.getMonth() + 1; if (month < 10) month = '0' + month
      return result + value.getDate() + '.' + month + '.' + value.getFullYear() + ', ' + weekDaysNames[value.getDay()]
    }
    if (format === 'date + weekday + reservedWords') {
      var today = new Date(Date.now())
      var yesterday = new Date(Date.now() - 1 * 24 * 3600 * 1000)
      var tomorrow = new Date(Date.now() + 1 * 24 * 3600 * 1000)
      var aftertomorrow = new Date(Date.now() + 2 * 24 * 3600 * 1000)
      if ((value.getDate() === today.getDate()) && (value.getMonth() === today.getMonth()) && (value.getFullYear() === today.getFullYear())) {
        return 'Сегодня, ' + weekDaysNames[value.getDay()]
      } else if ((value.getDate() === yesterday.getDate()) && (value.getMonth() === yesterday.getMonth()) && (value.getFullYear() === yesterday.getFullYear())) {
        return 'Вчера, ' + weekDaysNames[value.getDay()]
      } else if ((value.getDate() === tomorrow.getDate()) && (value.getMonth() === tomorrow.getMonth()) && (value.getFullYear() === tomorrow.getFullYear())) {
        return 'Завтра, ' + weekDaysNames[value.getDay()]
      } else if ((value.getDate() === aftertomorrow.getDate()) && (value.getMonth() === aftertomorrow.getMonth()) && (value.getFullYear() === aftertomorrow.getFullYear())) {
        return 'Послезавтра, ' + weekDaysNames[value.getDay()]
      } else {
        if (value.getDate() < 10) { result += '0' }
        month = value.getMonth() + 1; if (month < 10) month = '0' + month
        return result + value.getDate() + '.' + month + '.' + value.getFullYear() + ', ' + weekDaysNames[value.getDay()]
      }
    }
    if (format === 'date + time') {
      if (value.getDate() < 10) { result += '0' }
      month = (value.getMonth() + 1) >= 10 ? (value.getMonth() + 1) : ('0' + (value.getMonth() + 1))
      var hours = value.getHours(); if (hours < 10) hours = '0' + hours
      var minutes = value.getMinutes(); if (minutes < 10) minutes = '0' + minutes
      var seconds = value.getSeconds(); if (seconds < 10) seconds = '0' + seconds
      return result + value.getDate() + '.' + month + '.' + value.getFullYear() + ' ' + hours + ':' + minutes + ':' + seconds
    }
    if (format === 'timeWithoutSeconds') {
      hours = value.getHours(); if (hours < 10) hours = '0' + hours
      minutes = value.getMinutes(); if (minutes < 10) minutes = '0' + minutes
      return hours + ':' + minutes
    }
    // return moment(String(value), 'ddd MMM DD YYYY' /* здесь формат входных данных - нужен для momentjs для правильного парсинга */).format('DD, ddd')
    // return moment.tz(String(value), 'Europe/Moscow').format('DD, ddd')
  }
})

// value может быть string и: 2022-01-20T21:00:00.000Z или 12:00:00. или datetime но пока такого не было по коду но сразу и это обрабатываем
Vue.filter('formatTime', function (value, format) {
  if (value) {
    // var result = ''
    if (format === 'timeWithoutSeconds') {
      if ((typeof value === 'string') && (value.length <= 8)) {
        var hours = value.substring(0, 2)
        var minutes = value.substring(3, 5)
      } else {
        if (typeof value === 'string') value = new Date(value)
        hours = value.getHours(); if (hours < 10) hours = '0' + hours
        minutes = value.getMinutes(); if (minutes < 10) minutes = '0' + minutes
      }
      return hours + ':' + minutes
    }
  }
})

numeral.register('locale', 'ru', {
  delimiters: {
    thousands: ' ',
    decimal: ','
  }
})
// numeral.locale('en')
Vue.filter('money', function (value) {
  if (value === null) return null
  if (value === '') return ''
  // return numeral(value).format('0.0')
  var res = ''
  var str = Math.round(value).toString()

  while (str.length > 3) {
    res = ' ' + str.substring(str.length - 3, str.length) + res
    str = str.slice(0, -3)
  }
  res = str + res
  return res
})
Vue.filter('moneyWithSign', function (value) {
  if (value === null) return null
  if (value === '') return ''
  // return numeral(value).format('0.0')

  function isNumber (value) {
    return (value instanceof Number || typeof value === 'number') && !isNaN(value)
  }
  if (isNumber(value) !== true) return value

  var res = ''
  var str = Math.round(value).toString()

  while (str.length > 3) {
    res = ' ' + str.substring(str.length - 3, str.length) + res
    str = str.slice(0, -3)
  }
  res = str + res
  if (value > 0) res = '+ ' + res
  if (value < 0) res = '- ' + res.substring(1, res.length)
  return res
})
Vue.filter('moneyWithCentsWithSign', function (value) {
  if (value === null) return null
  if (value === '') return ''
  function isNumber (value) {
    return (value instanceof Number || typeof value === 'number') && !isNaN(value)
  }
  if (isNumber(value) !== true) return value

  var res = ''
  var str = (Math.round(value * 100) / 100).toString()
  var dotPosition = str.indexOf('.')
  var cents = ''
  if (dotPosition >= 0) {
    cents = str.substring(dotPosition, str.length)
    str = str.substring(0, dotPosition)
  }

  while (str.length > 3) {
    res = ' ' + str.substring(str.length - 3, str.length) + res
    str = str.slice(0, -3)
  }
  res = str + res
  res = res + cents

  if (value > 0) res = '+ ' + res
  if (value < 0) res = '- ' + res.substring(1, res.length)

  return res
})
Vue.filter('moneyWithCents', function (value) {
  if (value === null) return null
  if (value === '') return ''
  function isNumber (value) {
    return (value instanceof Number || typeof value === 'number') && !isNaN(value)
  }
  if (isNumber(value) !== true) return value

  var res = ''
  var str = (Math.round(value * 100) / 100).toString()
  var dotPosition = str.indexOf('.')
  var cents = ''
  if (dotPosition >= 0) {
    cents = str.substring(dotPosition, str.length)
    str = str.substring(0, dotPosition)
  }

  while (str.length > 3) {
    res = ' ' + str.substring(str.length - 3, str.length) + res
    str = str.slice(0, -3)
  }
  res = str + res
  res = res + cents
  return res
})

Vue.component('InputMoney', {
  props: ['value'],
  template: `
      <div style="width:100%; height:100%;">
          <div ref="unselect" tabindex=0></div>
          <input v-model="displayValue" @blur="isInputActive = false" @focus="isInputActive = true" @keydown="onKeyDown" class="input_money"/>
      </div>`,
  data: function () {
    return {
      isInputActive: false
    }
  },
  mounted: function () {
    var cssText = `
      .input_money{width:100%; height:100%; border: 1px solid #dddee1; border-radius: 4px; padding: 4px 7px 4px 7px;}
      .input_money:focus{
        outline:none !important; border-color:#9098c0; box-shadow:0 0 5px #ccc;
        transition: border .2s ease-in-out,background .2s ease-in-out,box-shadow .2s ease-in-out;
        transition-property: border, background, box-shadow;
        transition-duration: 0.2s, 0.2s, 0.2s;
        transition-timing-function: ease-in-out, ease-in-out, ease-in-out;
        transition-delay: 0s, 0s, 0s
      }
      .input_money:hover{
        border-color:#9098c0;
        transition: border .2s ease-in-out,background .2s ease-in-out,box-shadow .2s ease-in-out;
        transition-property: border, background, box-shadow;
        transition-duration: 0.2s, 0.2s, 0.2s;
        transition-timing-function: ease-in-out, ease-in-out, ease-in-out;
        transition-delay: 0s, 0s, 0s
      }
    `
    var css = document.createElement('style')
    css.type = 'text/css'
    css.setAttributeNode(document.createAttribute('scopped'))
    css.appendChild(document.createTextNode(cssText))
    this.$el.appendChild(css)
  },
  methods: {
    onKeyDown: function (event) {
      // console.log(event)
      if ((event.keyCode === 8 /* backspace */) ||
          (event.keyCode === 39 /* arrow right */) ||
          (event.keyCode === 37 /* arrow left */) ||
          (event.keyCode === 46 /* delete */)) {
      } else if (event.keyCode === 13) {
        this.$refs.unselect.focus()
      } else if ((event.keyCode < 48) || (event.keyCode > 57)) event.preventDefault() // не даем вводить не цифры
    }
  },
  computed: {
    displayValue: {
      get: function () {
        var res = ''
        var str = this.value
        if (this.isInputActive) {
          // Cursor is inside the input field. unformat display value for user
          return this.value
          /* res = ''
          str = this.value
          while (str.length > 3) {
            res = ' ' + str.substring(str.length - 3, str.length) + res
            str = str.slice(0, -3)
          }
          res = str + res
          return res */
        } else {
          res = ''
          str = this.value
          while (str.length > 3) {
            res = ' ' + str.substring(str.length - 3, str.length) + res
            str = str.slice(0, -3)
          }
          res = str + res
          return res
        }
      },
      set: function (modifiedValue) {
        let newValue = modifiedValue
        if (modifiedValue == null) newValue = ''
        if (typeof modifiedValue !== 'string') newValue = modifiedValue.toString()
        // newValue и modifiedValue - сейчас содержат все пробелы и другие символы, удалем их и устанвливаем в this.value через $emit
        newValue = newValue.replace(/[^\d.]/g, '')
        // Note: we cannot set this.value as it is a "prop". It needs to be passed to parent component
        // $emit the event so that parent component gets it
        this.$emit('input', newValue)
      }
    }
  }
})

Vue.component('InputPhone', {
  props: ['value', 'nextTabElId'],
  template: `
      <div class="input_phone_wrapper">
      <div class="input_phone" :class="{input_phone_focus: isInputActive == true, input_phone_error: isError}">
          <div ref="unselect"></div>
          <i class="fas fa-phone-square-alt input_phone_icon"></i>
          <input v-model="displayValue" @blur="isInputActive = false; onBlur()" @focus="isInputActive = true" @keydown="onKeyDown" class="input_phone_input"/>
      </div>
      <div class="input_phone_error_message" :class="{hidden: !isError}"><!--{{errorMsg}}--></div>
      </div>`,
  data: function () {
    return {
      isInputActive: false,
      isError: false,
      errorMsg: ''
    }
  },
  mounted: function () {
    var cssText = `
      .input_phone_wrapper{width:100%; font-size:14px;}
      .input_phone{width:100%; height:36px; border: 1px solid #dddee1; border-radius: 4px; padding:0;}
      .input_phone_focus{
        outline:none !important; border-color:#9098c0; box-shadow:0 0 5px #ccc;
        transition: border .2s ease-in-out,background .2s ease-in-out,box-shadow .2s ease-in-out;
        transition-property: border, background, box-shadow;
        transition-duration: 0.2s, 0.2s, 0.2s;
        transition-timing-function: ease-in-out, ease-in-out, ease-in-out;
        transition-delay: 0s, 0s, 0s
      }
      .input_phone:hover{
        border-color:#9098c0;
        transition: border .2s ease-in-out,background .2s ease-in-out,box-shadow .2s ease-in-out;
        transition-property: border, background, box-shadow;
        transition-duration: 0.2s, 0.2s, 0.2s;
        transition-timing-function: ease-in-out, ease-in-out, ease-in-out;
        transition-delay: 0s, 0s, 0s
      }
      .input_phone_icon{margin:9px 0px 0 8px; font-size:1.2em; position:absolute; left:3px; z-index:9; float:left;}
      .input_phone_input{border:none; width:100%; height:34px; padding:4px 7px 4px 2.2em; float:left;}
      .input_phone_input:focus{outline:none; /*border-color:#9098c0; box-shadow:0 0 5px #ccc;*/}
      .input_phone_error_message{
        position: absolute;
        top: 100%;
        left: 0;
        line-height: 1;
        padding-top: 6px;
        color: #ed3f14;
      }
      .input_phone_error{
        outline:none !important; border-color:#ed3f14;
        transition: border .2s ease-in-out,background .2s ease-in-out,box-shadow .2s ease-in-out;
        transition-property: border, background, box-shadow;
        transition-duration: 0.2s, 0.2s, 0.2s;
        transition-timing-function: ease-in-out, ease-in-out, ease-in-out;
        transition-delay: 0s, 0s, 0s
      }
    `
    var css = document.createElement('style')
    css.type = 'text/css'
    css.setAttributeNode(document.createAttribute('scopped'))
    css.appendChild(document.createTextNode(cssText))
    this.$el.appendChild(css)
  },
  methods: {
    onBlur: function () {
      this.isError = false
      if (this.value === '') {
        this.isError = true
        this.errorMsg = 'Поле не может быть пустым'
      } else if (this.value.length < 11) {
        this.isError = true
        this.errorMsg = 'Короткий номер телефона'
      }
      this.$emit('blur')
    },
    onKeyDown: function (event) {
      if ((event.keyCode === 8 /* backspace */) ||
          (event.keyCode === 39 /* arrow right */) ||
          (event.keyCode === 37 /* arrow left */) ||
          (event.keyCode === 46 /* delete */)) {
        if ((event.keyCode === 8) &&
            (event.target.selectionStart !== event.target.value.length) &&
            ((event.target.selectionStart === 1) ||
             (event.target.selectionStart === 3) ||
             (event.target.selectionStart === 4) ||
             (event.target.selectionStart === 8) ||
             (event.target.selectionStart === 9) ||
             (event.target.selectionStart === 13) ||
             (event.target.selectionStart === 16))) event.preventDefault() // не даем удалять спец формат символы
        if ((event.keyCode === 46) &&
            ((event.target.selectionStart === 0) ||
             (event.target.selectionStart === 2) ||
             (event.target.selectionStart === 3) ||
             (event.target.selectionStart === 7) ||
             (event.target.selectionStart === 8) ||
             (event.target.selectionStart === 12) ||
             (event.target.selectionStart === 15))) event.preventDefault() // не даем удалять спец формат символы
      } else if (event.keyCode === 9) { // ничего не делаем если tab. нельзя это добавть к enter, т.к. тогда следущий input перескакивает через одного
        this.onBlur()
      } else if ((event.keyCode === 13) || (event.keyCode === 0 /* 9 */)) {
        var el = document.getElementById(this.nextTabElId)
        if ((el != null) && (el.children[1] !== null)) {
          el.children[1].focus() // находим следующий input внутри iview-тэга 'Input'
        } else this.$refs.unselect.focus()
      } else if ((event.keyCode < 48) || (event.keyCode > 57)) {
        event.preventDefault() // не даем вводить не цифры
      } else if (event.target.value.length > 17) event.preventDefault() // не даем вводить номер длинее сотового номера
    }
  },
  computed: {
    displayValue: {
      get: function () {
        var res = ''
        var res0 = ''
        var res1 = ''
        var res2 = ''
        var res3 = ''
        var res4 = ''
        var str = this.value
        if (str == null) return ''
        res0 = str.substring(0, 1)
        res1 = str.substring(1, 4)
        res2 = str.substring(4, 7)
        res3 = str.substring(7, 9)
        res4 = str.substring(9, 11)
        if (res0 !== '') res = '+' + res0
        if (res1 !== '') res += ' (' + res1
        if (res1.length === 3) res += ') '
        if (res2 !== '') res += res2
        if (res2.length === 3) res += ' '
        if (res3 !== '') res += res3
        if (res3.length === 2) res += ' '
        if (res4 !== '') res += res4
        return res
      },
      set: function (modifiedValue) {
        let newValue = modifiedValue
        if (modifiedValue == null) newValue = ''
        if (typeof modifiedValue !== 'string') newValue = modifiedValue.toString()
        // newValue и modifiedValue - сейчас содержат все пробелы и другие символы, удалем их и устанвливаем в this.value через $emit
        newValue = newValue.replace(/[^\d.]/g, '')
        // Note: we cannot set this.value as it is a "prop". It needs to be passed to parent component
        // $emit the event so that parent component gets it
        this.$emit('input', newValue)
      }
    }
  }
})

Vue.config.productionTip = false
Vue.config.devtools = process.env.NODE_ENV !== 'production' // инструкция запрещает vue dev tool debugger открываться на этой странице если значение false

import App from './App'

/* eslint-disable no-new */
const app = new Vue({
  el: '#application',
  router: Router,
  store: Store,
  template: '<App/>',
  components: { App }
})

// для DEBUG ONLY - чтобы в браузерной консоли можно было менять данные у компонент.
// например команда: window.app.$store.commit('appStateServerConnectedSet', true)
window.app = app

window.cloneObject = cloneObject
window.cloneObjectWithoutFns = cloneObjectWithoutFns
window.mystrcmp = mystrcmp



// WEBPACK FOOTER //
// ./src/main.js